import React from "react";
import SectionHeader from "../../util/component/SectionHeader";
import { CarsharingRedirectParams, redirectToCarsharing } from "../../util/carsharingService";
import { useTranslation } from "react-i18next";

const CarSharingRedirectPage = () => {
    const opened = React.useRef(false);
    const { i18n } = useTranslation(["operation"]);

    const goToCarSharingHome = async () => {
        const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'HOME',
        };

        try {
            await redirectToCarsharing(redirectParams);
        } catch (error) {
            console.error('Redirect failed:', error);
        } finally {
            window.location.href = "/";
        }
    };

    React.useEffect(() => {
        if (!opened.current) {
            opened.current = true;
            goToCarSharingHome();
        }
    }, []);

    return (
        <div>
            <SectionHeader title="Redirecting" />
        </div>
    );
};

export default CarSharingRedirectPage;
